export default __webpack_public_path__ + "static/floor1_spec-f8418b1c4ef78594f05c0dc7c3f7f3e3.jpg";